import { FAVOURITES } from 'constants/requests'
import { URL_USER_FAVOURITES } from 'constants/urls'
import { RequestDefinition } from 'libraries/front-end-core/core/Api'

export const Favourites = new RequestDefinition({
  name: FAVOURITES,
  url: URL_USER_FAVOURITES,
  transform: (data: unknown) => data
})
